import React from "react";
import BaseLoader from "../constants/Loader";

export default function Loader({
  label = "Loading...",
  fullscreen = false,
  minHeight = "280px",
  background = "transparent",
  scale = 0.8,
}) {
  return (
    <div
      style={{
        width: "100%",
        minHeight: fullscreen ? "100vh" : minHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        boxSizing: "border-box",
        background,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
        }}
      >
        <div
          style={{
            width: "380px",
            height: "380px",
            position: "relative",
            transform: `scale(${scale})`,
            transformOrigin: "center",
          }}
        >
          <BaseLoader />
        </div>
        {label ? (
          <div
            style={{
              fontSize: "16px",
              fontWeight: 600,
              color: "#1e3a8a",
              textAlign: "center",
              marginTop: "-12px",
            }}
          >
            {label}
          </div>
        ) : null}
      </div>
    </div>
  );
}
